import { useState, memo, useCallback } from 'react';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCampaignsContext } from './CampaignsProvider';
import CampaignsPlatformSelect from './CampaignsPlatformSelect';
import { useFetchCampaignsAssociationSettings } from './hooks/useFetchCampaignsAssociationSettings';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CampaignsPlatformEditModal({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  onClose,
  objectBuilderUiProps
}) {
  const {
    saveCampaign
  } = useCampaignsContext();
  const [isSaving, setIsSaving] = useState(false);
  const onSave = useCallback(() => {
    setIsSaving(true);
    saveCampaign({
      objectType,
      assetId,
      crmIdProperty
    }).then(() => {
      onClose();
      setIsSaving(false);
    }).catch(() => {
      onClose();
      setIsSaving(false);
    });
  }, [assetId, crmIdProperty, objectType, onClose, saveCampaign]);
  const {
    data: associationSettings,
    loading: associationSettingsLoading
  } = useFetchCampaignsAssociationSettings();
  if (associationSettingsLoading || !associationSettings || !associationSettings[objectType]) {
    return null;
  }
  return /*#__PURE__*/_jsxs(UIModal, {
    "data-test-id": "campaigns-platform-edit-modal",
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.editCampaign"
        })
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "100",
        as: "div",
        children: /*#__PURE__*/_jsx(CampaignsPlatformSelect, {
          objectType: objectType,
          assetId: assetId,
          crmIdProperty: crmIdProperty,
          save: false,
          editorSelect: false,
          objectBuilderUiProps: objectBuilderUiProps
        })
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UILoadingButton, {
        use: "primary",
        onClick: onSave,
        loading: isSaving,
        "data-test-id": "campaigns-platform-edit-modal-button",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.saveEditCampaign"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: onClose,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "campaignSelect.cancelEditCampaign"
        })
      })]
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformEditModal);